import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { UI_MODAL_DATA } from "@webapp/ui/modal/modal.models";

export type ConfirmGoalDeleteModalData = {
  linkedMetrics: { name: string }[];
};

@Component({
  selector: "confirm-goal-delete",
  templateUrl: "confirm-goal-delete.component.html",
  styleUrls: ["confirm-goal-delete.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmGoalDeleteComponent {
  public linkedMetrics: { name: string }[];

  constructor(@Inject(UI_MODAL_DATA) modalData: ConfirmGoalDeleteModalData) {
    Object.assign(this, modalData);
  }
}
